
    import * as React from 'react';

    const Clock16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M8 15A7 7 0 108 1a7 7 0 000 14zm0-.75a6.25 6.25 0 110-12.5 6.25 6.25 0 010 12.5z" /><path d="M8.25 4v4.25h4.25V9h-5V4h.75z" /></svg>
        </div>
      );
    };

    Clock16.displayName = 'Clock16';

    export default Clock16;
  